import { config as envConfig } from 'ENV_CONFIG';
import { services } from '~/ocab-services/services.constant';
import qs from 'qs';

const getFromQueryParam = () => qs.parse(window.location.search, { ignoreQueryPrefix: true }).appointmentTypeId;

export const getAppointmentsDetails = (appointmentType) => {
  const appointmentTypeId = appointmentType.id ? appointmentType.id : getFromQueryParam();
  const service = envConfig.services[services.BEAUTY_SOCIETY.name];
  const journey = service.appointmentTypes[appointmentTypeId]?.analyticsJourneyName || service.analyticsJourneyName;

  return ({
    journey,
    branchId: '',
  });
};
